export default __webpack_public_path__ + "static/media/DE3N2Y-min.32e2e7bf.jpg";